<template>
  <form-po
    ref="Form"
    :data="data"
    :dataID="data.id"
    :model="getModel"
    @updateModelItem="handlerUpdateModelItem"
    @change="$emit('change', $event)"
  />
</template>

<script>
import FormWrapperAutoSave from '@/components/Form/FormWrapperAutoSave'
export default {
  name: 'SectionShipping',
  mixins: [FormWrapperAutoSave],
  components: {
    'form-po': () => import(/* webpackChunkName: 'SupplierPoRFQ2' */ './FormPO.vue')
  },
  props: {
    data: { type: Object }
  },
  computed: {
    isAvailableToSave () {
      return true
    }
  },
  created () {
    this.$bus.$onPromise('validate-all-sections', this.validate)
  },
  beforeDestroy () {
    this.$bus.$offPromise('validate-all-sections', this.validate)
  },
  methods: {
    getModel () {
      return {
        id: null,
        shipToCompanyID: null,
        shipToCompanyDetailID: null,
        shipToCompanyContactID: null,
        shippingPorformaNumber: '',
        noOfBoxes: '',
        shipViaForwarderID: null,
        awb: '',
        awbOutRCVDBySupplier: false,
        awbComingInDetails: '',
        awbComingRCVD: '',
        paymentChequeNo: null
      }
    },
    validate () {
      return this.$refs.Form.validate()
    }
  }
}
</script>
